import { Box, Button, Typography } from "@mui/material";
import { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Add as AddIcon,
  ListAlt as ListAltIcon,
  PostAdd as PostAddIcon,
  CheckCircle as CheckCircleIcon
} from "@mui/icons-material";
import {
  canCreateBroker,
  canUseOnboardingRequests
} from "../../../../auth/permissions";
import { useRoles } from "../../../../auth/useRoles";

type Props = {};

export const BrokersGridMenu: FC<Props> = () => {
  const roles = useRoles();
  const location = useLocation();
  const showCreateBroker = canCreateBroker(roles);
  const showOnboardingRequests = canUseOnboardingRequests(roles);
  const isCompletedPage = location.pathname.startsWith("/brokers/completed");

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", marginRight: 2 }}>
        <Typography sx={{ marginLeft: 1 }} variant="h5" component="span">
          {isCompletedPage ? "Completed Brokers" : "Brokers"}
        </Typography>
      </Box>
      <Box display="flex" gap={1}>
        {!isCompletedPage && (
          <Link to="/brokers/completed">
            <Button variant="outlined" startIcon={<CheckCircleIcon />}>
              Completed
            </Button>
          </Link>
        )}
        {showOnboardingRequests && !isCompletedPage && (
          <>
            <Link to="/brokers/request-new">
              <Button variant="outlined" startIcon={<PostAddIcon />}>
                Request
              </Button>
            </Link>
            <Link to="/brokers/my-requests">
              <Button variant="outlined" startIcon={<ListAltIcon />}>
                My requests
              </Button>
            </Link>
          </>
        )}
        {showCreateBroker && !isCompletedPage && (
          <Link to="/brokers/new">
            <Button variant="contained" startIcon={<AddIcon />}>
              Onboard new broker
            </Button>
          </Link>
        )}
      </Box>
    </Box>
  );
};
